import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/common/user/user.service';
import { UserStateService } from 'src/app/services/common/user/user-state.service';
import { AuthService } from 'src/app/services/core/auth/auth.service';
import { TokenStorageService } from 'src/app/services/core/auth/token-storage.service';
import { ConstantService } from 'src/app/shared/constant/constant.service';
import { UserIdentity } from 'src/app/shared/models/user.models';

import { routes } from '../../../../consts';
import { User } from '../../../../pages/auth/models';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent implements OnInit {
  @Input() user: User;
  @Output() signOut: EventEmitter<void> = new EventEmitter<void>();
  public routes: typeof routes = routes;
  public flatlogicEmail: string = 'https://flatlogic.com';
  userId: string;
  userIdentity: UserIdentity;
  loading: boolean = true;
  isMenuOpened: boolean = false;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private userStateService: UserStateService,
  ) {}

  ngOnInit() {
    this.userId = this.tokenStorage.getUserId() ?? '';
    if (!this.userId) {
      this.loading = false;
      return;
    }

    this.applyStateFallback();

    this.userService.getUserIdentity(this.userId).subscribe({
      next: (data: UserIdentity) => {
        this.userIdentity = {
          ...this.userIdentity,
          ...data,
        };
        this.loading = false;
        if (data?.roles) {
          localStorage.setItem(
            ConstantService.localStorageKeys.role,
            JSON.stringify(data.roles),
          );
        }
        if (data?.planName) {
          localStorage.setItem(
            ConstantService.localStorageKeys.plan_name,
            data.planName,
          );
        }
      },
      error: () => {
        this.applyStateFallback();
        this.loading = false;
      },
    });
  }

  private applyStateFallback(): void {
    const stateUser = this.userStateService.user()?.user;
    if (!stateUser) {
      return;
    }

    this.userIdentity = {
      ...(this.userIdentity ?? {}),
      roles: stateUser.roles ?? this.userIdentity?.roles,
      profile: {
        name: stateUser.name || stateUser.email,
        photoUrl: '',
      },
    } as UserIdentity;
  }

  public signOutEmit(): void {
    this.signOut.emit();
  }
  async clearData() {
    await this.authService.logoutUser();
  }

  navigate() {
    this.router.navigate(['/auth/login']);
  }
  public openMenu(): void {
    this.isMenuOpened = !this.isMenuOpened;
  }
}
